<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>分类管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button
          type="success"
          style="margin-left: 8vh"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="mini"
          >新增分类</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="sort" label="排序" align="center" />
      <el-table-column prop="title" label="分类名称" align="center" />
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
      :lock-scroll="false"
      :append-to-body="true"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="排序" prop="sort">
              <el-input
                v-model="form.sort"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="分类名称" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import tableCommon from "../../../mixins/table-common";
import {
  getclassifyList,
  addclassify,
  deleteclassify,
  editclassify,
} from "../../api/classify";
export default {
  mixins: [tableCommon],
  data() {
    return {
      // 请求地址api
      api: {
        list: getclassifyList,
        add: addclassify,
        del: deleteclassify,
        edit: editclassify,
      },
      // 规则验证
      rules: {
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 传参
      form: {
        status: "1",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
      },
      tableData: [],
    };
  },
  methods: {
    // 状态修改
    changeStatus(res) {
      this.form = JSON.parse(JSON.stringify(res));
      // this.handleEdit();
      this.actionType = "edit";
      // const { city_name, company_name, ...rest } = this.form;
      // this.form = rest;
      editclassify(this.form).then((msg) => {
        if (msg.code !== 200) return this.$message("获取状态失败");
      });
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.form.status = 1;
      this.handleAdd();
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
  },
};
</script>
<style scoped>
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/information/classify.vue